<template>
  <div class="bg">
      <LoginCard @login="onLogin" @gotoSignup="handleGotoSignup" :isLoading="isLoading" />
      <!-- <v-switch
          class="mb-1 mr-1 mx-auto my-auto"
            v-model="dark"
            inset
            label="深色模式"
            @change="onChangeSwitchDarkTheme"
          >
          </v-switch> -->
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
//例如: import <组件名称> from  <组建路径>
import LoginCard from "./widgets/mv-card-login.vue";
import { i18n } from "@/plugins/i18n.js"

import {
  wd_globalSignIn,
  wd_globalGetUserJoinStatus,
  wd_corporationLookup,
  wd_corporationSignIn,
  api_AccountsJoinCorporation
} from "@/service/apiLogin.js";

import { api_get_palns } from "@/views/subscriotion/services/subscriptionApi.js";

import { userKeys, wdConfigData } from "@/service/wd_app_config.js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    LoginCard,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      isLoading: false,
      locales: [
        {
          title: "English",
          locale: "en",
        },
        {
          title: "简体中文",
          locale: "zhHans",
        },
      ],
      products: [],
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    handleGotoSignup() {
      this.$emit("switchMode", "signup");
    },  
    onLogin(params) {
      localStorage.setItem(userKeys.key_accountName, params.accountName);
      localStorage.setItem(userKeys.key_accountType, params.accountType);
      this.isLoading = true;
      this.globalSignIn(params)
    },
    globalSignIn(params) {
      const that = this
      wd_globalSignIn(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleGlobalSign(response);
          } else {
            that.isLoading = false;
            that.$message.error(response.data.Description);
          }
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        }
      );
    },
    handleGlobalSign(response) {
      localStorage.setItem(
        userKeys.key_globalAccessToken,
        response.data.Result.GlobalAccessToken
      );
      localStorage.setItem(
        userKeys.key_globalRefreshToken,
        response.data.Result.GlobalRefreshToken
      );
      var params = {
        globalAccessToken: response.data.Result.GlobalAccessToken,
      };
      this.userJoinStatus(params)
      /*wd_globalGetUser(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleGlobalGetUser(response);
          } else {
            that.isLoading = false;
            that.$message.error(response.data.Description);
          }
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        }
      );*/
    },
    /*handleGlobalGetUser(response) {
      if (response.data.Result.Accounts.length > 0) {
        // 0: {Name: "qin@m2s.com", Type: 1, IsVerified: true}
        // 先不处理，只要有账号，继续往下进行
        var that = this;
        var params = {
          globalAccessToken: localStorage.getItem(
            userKeys.key_globalAccessToken
          ),
        };
        that.userJoinStatus(params)
      } else {
        that.isLoading = false;
        that.$message.error(response.data.Description);
      }
    },*/
    userJoinStatus(params) {
      const that = this
      wd_globalGetUserJoinStatus(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleGlobalGetUserJoinStatus(response);
          } else {
            that.isLoading = false;
            that.$message.error(response.data.Description);
          }
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        }
      );
    },
    handleGlobalGetUserJoinStatus(response) {
      /*Result: {CorporationId: "a8304d567bba4d700000000000000000", ApplicantStatus: 32}*/
      if (response.data.Result.ApplicantStatus == 32) {
        localStorage.setItem(
          userKeys.key_corporationId,
          response.data.Result.CorporationId
        );
        var params = {
          accountName: localStorage.getItem(userKeys.key_accountName),
          accountType: localStorage.getItem(userKeys.key_accountType),
        };
        this.corporationLookup(params)
      } else if (response.data.Result.ApplicantStatus == 48)  {
        this.isLoading = false;
        this.joinCorporation()
      } else {
        this.isLoading = false;
        this.$message.error("Login failed.");
      }
    },
    corporationLookup(params) {
      const that = this
      wd_corporationLookup(params).then(
        (response) => {
          that.handleGlobalCorporationLookup(response);
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        });
    },
    handleGlobalCorporationLookup(response) {
      localStorage.setItem(
        userKeys.key_serviceUrl_ImageHub,
        response.data.SecureImageHubService
      );
      /*localStorage.setItem(
        userKeys.key_serviceUrl_Dir,
        response.data.SecureDirectoryService
      );
      localStorage.setItem(
        userKeys.key_serviceUrl_Task,
        response.data.SecureTaskForceService
      );
      localStorage.setItem(
        userKeys.key_serviceUrl_Talk,
        response.data.SecureTalkTimeService
      );
      localStorage.setItem(
        userKeys.key_serviceUrl_Calendar,
        response.data.SecureCalendarGridService
      );
      localStorage.setItem(
        userKeys.key_serviceUrl_An,
        response.data.SecureAggregatedNotificationService
      );*/
      this.corporationSignIn()
      // install
      /* var that = this;
      var params = {
        deviceNativeId: UUID(),
      };
      wd_install(params).then(
        (response) => {
          that.handleCorporationServiceInstall(response);
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        }
      ); */
    },
    // handleCorporationServiceInstall(response) {
    //   /* localStorage.setItem(userKeys.key_deviceId, response.data.DeviceId);*/
    //   localStorage.setItem(
    //     userKeys.key_clientInstallationId,
    //     response.data.ClientInstallationId
    //   );
    //   var params = {
    //     clientInstallationId: response.data.ClientInstallationId,
    //   };
    //   this.corporationSignIn()
    // },
    corporationSignIn(){
      const that = this
      wd_corporationSignIn().then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleCorporationServiceSignIn(response);
          } else {
            that.isLoading = false;
            that.$message.error(response.data.Description);
          }
        },
        (error) => {
          that.isLoading = false;
          that.$message.error(error);
        }
      );
    },
    handleCorporationServiceSignIn(response) {
      localStorage.setItem(
        userKeys.key_corporationAccessToken,
        response.data.Result.AccessToken
      );
      localStorage.setItem(
        userKeys.key_user_settings_image_style_index,
        0
      );
      /* localStorage.setItem(
        userKeys.key_corporationObject,
        JSON.stringify(response.data.Result.Corporation)
      ); */
      localStorage.setItem(
        userKeys.key_userObject,
        JSON.stringify(response.data.Result.User)
      );
      //手动设置语言
      i18n.locale = wdConfigData.localLanguage
      localStorage.setItem('locale', userKeys.localLanguage)
      
      // after login, need to redirect to the target page
      const action = localStorage.getItem("welcome_action");
      const id = localStorage.getItem("welcome_id");
      if (action && id) {
        if (action == "product") {
          // judge from localStorage first, if not exist, then call api to get product list
          const productList = JSON.parse(localStorage.getItem("productList") || "[]");
          // if localStorage has no productList, productList length is 0, then need to call api to get product data, and then redirect
          if (productList.length == 0) {
            this.loadProducts(id);
          } else {
            const product = productList.find(p => p.Id == id);
            if (product) {
              this.$router.push({
                name: 'checkout',
                params: { product: product }
              });
            } else {
              this.$message.warning('No corresponding product subscription found. Please go to the product subscription page to confirm your purchase.');
              // subscriptions?tab=buy-subscriptions
              this.$router.push('/subscriptions?tab=buy-subscriptions');
            }
          }
        } else {
          this.$router.push('/subscriptions?tab=buy-subscriptions');
        }
      } else {
        this.$router.push("/subscriptions")
      }
    },
    joinCorporation() {
      const that = this
      // hardCode CorporationId: individal account in the one company:4db819d099b442bd0000000000000000
      const params = {
        corporationId:'4db819d0-99b4-42bd-0000-000000000000',
        globalAccessToken: localStorage.getItem(userKeys.key_globalAccessToken)
      }
      api_AccountsJoinCorporation(params).then(
        (response) => {
          if (response.data.Code == 0) {
            that.handleRegisterUser(response);
          } else {
            that.$message.error(response.data.Description);
          }
        },
        () => {
          that.$message.error(this.$i18n.t("ppt_add_in_main.server_general_error_message"))
        }
      );
    },
    handleRegisterUser() {
      this.$message.success(this.$i18n.t("ppt_add_in_main.signup_success_show_user_msg"));
      this.$router.replace("/login");
    },
    loadProducts(id) {
      try {
        var that = this;
        api_get_palns().then(
            (response) => {
              that.handleGetPlansResponse(response, id);
            },
            (error) => {
              console.error(error);
              this.$router.push('/subscriptions?tab=buy-subscriptions');
            }
        );
      } catch (error) {
        console.error('Failed to load products:', error);
        this.$router.push('/subscriptions?tab=buy-subscriptions');
      }
    },
    handleGetPlansResponse(response, id) {
      if (response.data.Code === 0) {
        this.products = response.data.Result.Plans.sort((a, b) => {
          const nameA = a.Name.toLowerCase();
          const nameB = b.Name.toLowerCase();

          // 判断是否包含 Plus / Pro
          const isPlusA = nameA.includes("plus");
          const isPlusB = nameB.includes("plus");
          const isProA  = nameA.includes("pro");
          const isProB  = nameB.includes("pro");

          // 赋值排序权重 (0 无 Plus/Pro, 1 Plus, 2 Pro)
          const weightA = isPlusA ? 1 : isProA ? 2 : 0;
          const weightB = isPlusB ? 1 : isProB ? 2 : 0;

          // 先按权重排：无 > Plus > Pro
          if (weightA !== weightB) {
            return weightA - weightB;
          }
          // 同类情况下按 Priority 从小到大
          return a.Priority - b.Priority;
        });
        for (let i = 0; i < this.products.length; i++) {
          this.products[i].Description = this.splitStringToArray(this.products[i].Description);
        }
        localStorage.setItem('productList', JSON.stringify(this.products ? this.products : []));

        const product = this.products.find(p => p.Id == id);
        this.$router.push({
          name: 'checkout',
          params: { product: product }
        });
      } else {
        console.error('Failed to get plans:', response.message);
        this.$router.push('/subscriptions?tab=buy-subscriptions');
      }
    },
    splitStringToArray(str) {
      if (!str) return [];
      const separator = str.includes('，') ? '，' : ', ';
      
      return str
        .split(separator)
        .map(item => item.trim())
        .filter(item => item !== '');
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
  },
  destroyed() {}, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style scoped>
.bg {
  /* height: fill-height; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url('@/assets/web_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; */
}
</style>
